window.app.controller('tabsController', ['$scope', '$http', '$compile', '$mdDialog', function ($scope, $http, $compile, $mdDialog) {
    $scope.setFocusLine = function () {
        setTimeout(function () { $scope.focusLine() }, 0)
    }
    $scope.tabsCtrl = function () {
        $scope.setFocusLine();

        $scope.tabsToggle = (btn, block) => {
            if (localStorage.getItem('offerHasBeenCreated')) {
                $('.tabs__item ').removeClass('open');
                $('.tab--partner-offers').addClass('open');
                $('.office__view--partner-profile').slideUp();
                $('.office__view--partner-offers').slideDown();
                localStorage.removeItem('offerHasBeenCreated')
            }
            $(`.${btn}`).click(function () {
                if (!$(this).hasClass('open')) {
                    $(`.${btn}`).removeClass('open');
                    $(this).addClass('open');
                    $(`.${block}`).slideUp();
                    $(`.${block}` + `[data-content=` + $(this).attr('data-ctrl') + ']').slideDown();
                    //$scope.focusLine();
                    $scope.scrollTo('body', 300);
                }
            });
        }
        $scope.tabsToggle('tabCTRL', 'tabContent');
        $scope.tabsToggle('categoryTabsCTRL', 'tabCategoryOffers');


    }

    $scope.focusLine = function () {
        var e = $('.tabCTRL.open')[0];
        if (typeof e !== "undefined") {
            var l = e.offsetLeft + 'px';
            var t = e.offsetTop + 'px';
            var w = e.offsetWidth + 'px';
            var h = e.offsetHeight + 'px';
        }
        //console.log(l, t, w, h, e);
        if ($(window).width() <= 600) {
            $('.focus-line').css({ left: l, height: '5px', width: w, top: '95%' });
        }
        else {
            $('.focus-line').css({ left: 0, height: h, width: '5px', top: t });
        }
    }

    $scope.checkRequiredFields = (requiredFields) => {
        if (requiredFields === "false") {
            $mdDialog.show({
                preserveScope: true,
                template:
                    `<div id="modal-popup">
                    <p class="title text-center">Przed stworzeniem oferty wypełnij wymagane pola swojego profilu i dołącz logo w rubryce Profil.</p>
                    <div class="layout" layout-align="center">
                        <button class="action-btn" ng-click="redirectToProfile()" aria-label="go">przejdź</button>
                    </div>
                </div>`,
                parent: angular.element(document.body),
                scope: $scope,
            })
        }
    }

    $scope.redirectToProfile = () => {
        $mdDialog.hide()
        $scope.setClick('.tab--partner-profile');
    }

    $scope.redirectToConstructor = (requiredFields) => {
        $scope.setClick('.tab--partner-offer-constructor');
        $scope.checkRequiredFields(requiredFields);
    }

}])



// WEBPACK FOOTER //
// src/js/controllers/tabsController.js